import React, { useState } from "react";
import "./GalleryPage.css";

const GalleryPage = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const galleryData = [
    { id: 1, category: "Villa", img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c" },
    { id: 2, category: "Apartment", img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c" },
    { id: 3, category: "Villa", img: "https://images.unsplash.com/photo-1600047509358-9dc75507daeb" },
    { id: 4, category: "Penthouse", img: "https://images.unsplash.com/photo-1600573472591-ee6b68d14c68" },
    { id: 5, category: "Villa", img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c" },
    { id: 6, category: "Apartment", img: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3" },
    { id: 7, category: "Penthouse", img: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0" },
    { id: 8, category: "Villa", img: "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6" },
  ];

  const filteredImages =
    activeCategory === "All"
      ? galleryData
      : galleryData.filter(item => item.category === activeCategory);

  return (
    <section className="mg-wrapper">
      <div className="mg-header">
        <h1 className="mg-title">Our Property Gallery</h1>
        <p className="mg-subtitle">
          Discover luxury living spaces crafted for modern lifestyles
        </p>
      </div>

      <div className="mg-filters">
        {["All", "Villa", "Apartment", "Penthouse"].map(category => (
          <button
            key={category}
            className={`mg-filter-btn ${activeCategory === category ? "active" : ""}`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="mg-grid">
        {filteredImages.map(item => (
          <div className="mg-card" key={item.id}>
            <img src={item.img} alt="property" />
            <div className="mg-overlay">
              <span>{item.category}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GalleryPage;